// extracted by mini-css-extract-plugin
export var container = "phone-carousel-module--container--9c58b";
export var navButton = "phone-carousel-module--navButton--79c53";
export var phone = "phone-carousel-module--phone--01cdf";
export var wrapper = "phone-carousel-module--wrapper--952bc";